export default __webpack_public_path__ + "static/media/Front.27b04cc4.png";